<template>
	<div class="brick">
		<div class="content_area" style="overflow: hidden;">
			<div ref="top_box1" class="left_big4_tbl padding_10">
				<div class="fl_l mgr_15">
					<h4 class="h4_title">Shipping Address</h4>
					<h5 class="h5_title">{{ order.partner_name }}</h5>
					<h5 v-if="order.shipped_address_detail" class="h5_title">{{ order.shipped_address_detail }}</h5>
					<h5 class="h5_title">
						<span class="mgr_5" v-if="order.shipped_address_city">{{ order.shipped_address_city }}</span>
						<span class="mgr_5" v-if="order.shipped_address_state">{{ order.shipped_address_state }}</span>
						<span class="mgr_5" v-if="order.shipped_address_country">{{ order.country_name || order.shipped_address_country }}</span>
						<span v-if="order.shipped_zipcode">({{ order.shipped_zipcode }})</span>
					</h5>
					<h5 v-if="order.ship_telephone" class="h5_title">{{ order.ship_telephone }}</h5>
				</div>
				<div class="fl_l mgr_15 pdl_20">
					<h4 class="h4_title" style="display: inline-block;">Order No :</h4>
					<h5 class="h5_title" style="display: inline-block;">{{ order.order_no | fillZeroForDisplayNo(8) }}</h5>
					<br />
					<h4 class="h4_title" style="display: inline-block;">Order Date :</h4>
					<h5 class="h5_title" style="display: inline-block;">{{ order.crt_dt }}</h5>
					<br />
					<h4 class="h4_title" style="display: inline-block;">Status :</h4>
					<h5 class="h5_title" style="display: inline-block;">
						<span v-if="order.invoice_no">Accepted({{ order.invoice_status | saleStatusName }})</span>
						<span v-else-if="order.order_status === 'O'">Before Accept</span>
						<span v-else-if="order.order_status === 'R'">Reject</span>
					</h5>
					<br />
					<template v-if="order.order_status === 'A'">
						<h4 class="h4_title" style="display: inline-block;">Accept Date :</h4>
						<h5 class="h5_title" style="display: inline-block;">{{ order.process_dt }}</h5>
						<br />
						<template v-if="order.status_reason">
							<h4 class="h4_title" style="display: inline-block;">Accept Reason :</h4>
							<h5 class="h5_title" style="display: inline-block;">{{ order.status_reason }}</h5>
							<br />
						</template>
					</template>
					<template v-else-if="order.order_status === 'R'">
						<h4 class="h4_title" style="display: inline-block;">Reject Date :</h4>
						<h5 class="h5_title" style="display: inline-block;">{{ order.process_dt }}</h5>
						<br />
						<h4 class="h4_title" style="display: inline-block;">Reject Reason :</h4>
						<h5 class="h5_title" style="display: inline-block;">{{ order.status_reason }}</h5>
						<br />
					</template>
				</div>
				<div v-if="order.order_status === 'A'" class="fl_l pdl_20">
					<h4 class="h4_title" style="display: inline-block;">SO No :</h4>
					<h5 class="h5_title" style="display: inline-block;">
						<a href="javascript: void(0);" @click="selectInvoice(order.invoice_no)">{{ order.so_dn }}</a>
					</h5>
					<br />
					<template v-if="order.invoice_dn">
						<h4 class="h4_title" style="display: inline-block;">Invoice No :</h4>
						<h5 class="h5_title" style="display: inline-block;">
							<a href="javascript: void(0);" @click="selectInvoice(order.invoice_no, 'invoice')">{{ order.invoice_dn }}</a>
						</h5>
						<br />
					</template>
				</div>
			</div>
			<div ref="top_box2" class="right_small4_tbl padding_10">
				<h4 class="h4_title">Customer's Memo</h4>
				<p>
					{{ order.customer_memo }}
				</p>
			</div>
		</div>
		<div class="content_area" style="overflow: hidden;">
			<div class="left_big4_tbl padding_10">
				<h4 class="h4_title">Order Items</h4>
				<table class="list_tbl mgb_20">
					<template v-if="order.order_status === 'O'">
						<colgroup>
							<col style="width: 5%;" />
							<col style="width: 43%;" />
							<col style="width: 12%;" />
							<col style="width: 8%;" />
							<col style="width: 8%;" />
							<col style="width: 8%;" />
							<col style="width: 8%;" />
							<col style="width: 8%;" />
						</colgroup>
						<thead>
							<tr>
								<th>Pic</th>
								<th>Description</th>
								<th>Color</th>
								<th>Price($)</th>
								<th>Qty</th>
								<th>Amount($)</th>
								<th>Available Qty</th>
								<th>On Hand</th>
							</tr>
						</thead>
					</template>
					<template v-else>
						<colgroup>
							<col style="width: 5%;" />
							<col style="width: 43%;" />
							<col style="width: 13%;" />
							<col style="width: 13%;" />
							<col style="width: 13%;" />
							<col style="width: 13%;" />
						</colgroup>
						<thead>
							<tr>
								<th>Pic</th>
								<th>Description</th>
								<th>Color</th>
								<th>Price($)</th>
								<th>Qty</th>
								<th>Amount($)</th>
							</tr>
						</thead>
					</template>

					<tbody>
						<tr v-for="(item, index) in items" :key="index" :class="{ red_background: order.order_status === 'O' && item.available_quantity - item.qty < 1 }">
							<td>
								<div class="squal_photo_wrap">
									<div class="photo_container">
										<img :src="item.image_url" alt="Not Found" />
									</div>
								</div>
							</td>
							<td>{{ item.item_name }}</td>
							<td>{{ item.color_name }}</td>
							<td class="al_right">{{ item.price | toCurrency }}</td>
							<td class="al_right">
								<!--
								<currency-input
									type="text"
									class="tbl_int ssm_int al_right"
									ref="item_qty"
									v-model="item.qty"
									:precision="0"
									:disabled="!(modifiable && !order.invoice_no)"
									@input="changeAmount(item)"
									@focus="$event.target.select()"
									@keydown.up.prevent="$refs.item_qty[index - 1 < 0 ? items.length - 1 : index - 1].$el.select()"
									@keydown.down.prevent="$refs.item_qty[index + 1 > items.length - 1 ? 0 : index + 1].$el.select()"
								/> -->
								{{ item.qty | commaSeparated }}
							</td>
							<td class="al_right">{{ item.amount | toCurrency }}</td>
							<template v-if="order.order_status === 'O'">
								<td class="al_right">{{ item.available_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							</template>
						</tr>
					</tbody>
				</table>
				<div class="bottom_bt_box">
					<p class="h5_title al_right mgb_20">Order Amount: ${{ order.order_amount || 0 | toCurrency }} | Order Quantity: {{ order.order_qty || 0 | commaSeparated }}</p>
					<ul v-if="modifiable && order.order_status === 'O'">
						<li>
							<a href="javascript:;" class="gray_bt" @click="acceptRetailOrder">Accept</a>
						</li>
						<li>
							<a href="javascript:;" class="gray_bt" @click="openRejectModal">Reject</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<RejectModal v-if="reject_modal" @close="closeRejectModal" @reject="rejectRetailOrder" />
	</div>
</template>

<script>
import RejectModal from '@/views/sales/retailStore/RejectModal';
import { apiSelectRetailOrderDetail, apiAcceptRetailOrder, apiRejectRetailOrder } from '@/api/sales/retail';
export default {
	data: () => ({
		order_no: 0,
		order: {},
		items: [],

		query: ['order_no', 'back_uri'],
		back_uri: null,

		// 주문 거절 시 출력 모달
		reject_modal: false,
	}),
	components: {
		RejectModal,
	},
	computed: {
		modifiable: {
			get: function() {
				let menus = this.$session.get('menus');
				for (let menu of menus) {
					if (menu.path === this.$router.history.current.path && menu.modify_yn === 'Y') return true;
				}
				return false;
			},
		},
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
	},
	methods: {
		openRejectModal() {
			this.reject_modal = true;
		},
		closeRejectModal() {
			this.reject_modal = false;
		},
		selectInvoice(invoice_no, type) {
			let routeData;
			if (type == 'invoice') {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no } });
				window.open(routeData.href, 'herp_invoice');
				// this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			} else {
				routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no } });
				window.open(routeData.href, 'herp_so');
			}

			//let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			//window.open(routeData.href, '_blank');
		},
		async acceptRetailOrder() {
			let { status } = await apiAcceptRetailOrder(this.order);
			if (status === 200) {
				this.$toast.success('Success To Accept Order');
				this.goBackUri();
			} else this.$toast.error('Failure To Accept Order');
		},
		async rejectRetailOrder(status_reason) {
			this.order.status_reason = status_reason;
			let { status } = await apiRejectRetailOrder(this.order);
			if (status === 200) {
				this.$toast.success('Success To Reject Order');
				this.goBackUri();
			} else this.$toast.error('Failure To Reject Order');
		},
		goBackUri() {
			this.$router.push({ path: this.back_uri });
		},
		/*
		calcTotalAmountNQty() {
			let order_qty = 0;
			let order_amount = 0;

			this.items.forEach(item => {
				order_qty += item.qty;
				order_amount += item.amount;
			});

			this.order.order_qty = order_qty;
			this.order.order_amount = order_amount;
		},
		changeAmount(item) {
			item.amount = item.qty * item.price;
			this.calcTotalAmountNQty();
		},*/
		equalizeTopBoxesHeight() {
			this.$nextTick(() => {
				let box1 = this.$refs.top_box1;
				let box2 = this.$refs.top_box2;

				if (box1.getBoundingClientRect().height > box2.getBoundingClientRect().height) box2.style.height = box1.getBoundingClientRect().height + 'px';
				else if (box1.getBoundingClientRect().height < box2.getBoundingClientRect().height) box1.style.height = box2.getBoundingClientRect().height + 'px';
			});
		},
		async selectRetailOrderDetail() {
			let { data } = await apiSelectRetailOrderDetail(this.order_no);
			// console.log(data);
			this.order = data;
			this.items = this.order.item_list;
			this.items.forEach(it => (it.image_url = process.env.VUE_APP_API_URL + '/file/' + this.company_id + '/' + it.image_file_name));
		},
		async init() {
			for (let prop of this.query) {
				if (this.$route.query[prop]) this.$data[prop] = this.$route.query[prop];
			}

			await this.selectRetailOrderDetail();
			this.equalizeTopBoxesHeight();
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped>
.padding_10 {
	padding: 10px;
}
/* height가 고정 값이 아닌 너비를 100%로 하여 고정 비율로 화면에 출력 */
.squal_photo_wrap {
	position: relative;
	width: 100%;
	height: 0; /* 하위요소의 position을 absolute로 하지 않을 경우, 본 요소가 화면에서 차지하는 영역이 없기 때문에 하위요소도 화면에 표시되지 않음. */
	overflow: hidden;
	padding-top: 133%; /* 가로/세로 * 100 */
}
.circle_photo_wrap {
	position: relative;
	width: 100%;
	height: 0; /* 하위요소의 position을 absolute로 하지 않을 경우, 본 요소가 화면에서 차지하는 영역이 없기 때문에 하위요소도 화면에 표시되지 않음. */
	overflow: hidden;
	padding-top: 100%; /* 가로/세로 * 100 */
}

.photo_container {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.photo_container img {
	width: 100%;
	height: auto;
	margin-top: 10px;
}

.red_background td {
	background: #ff8800 !important;
}
.red_background:hover td {
	background: #ffc300 !important;
}
</style>
